/* tslint:disable */
/* eslint-disable */
/**
 * Telematics API
 * Telematics services API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PushyMeRegDevicesRes
 */
export interface PushyMeRegDevicesRes {
    /**
     * 
     * @type {{ [key: string]: Array<string>; }}
     * @memberof PushyMeRegDevicesRes
     */
    devices: { [key: string]: Array<string>; };
}

export function PushyMeRegDevicesResFromJSON(json: any): PushyMeRegDevicesRes {
    return PushyMeRegDevicesResFromJSONTyped(json, false);
}

export function PushyMeRegDevicesResFromJSONTyped(json: any, ignoreDiscriminator: boolean): PushyMeRegDevicesRes {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'devices': json['devices'],
    };
}

export function PushyMeRegDevicesResToJSON(value?: PushyMeRegDevicesRes | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'devices': value.devices,
    };
}


